export const FIREBASE_UNIQUE_ERROR_CODES = {
    USER_NOT_FOUND: "auth/user-not-found",
    REQUIRES_RECENT_LOGIN: "auth/requires-recent-login",
};

export const LOGOUT_AFTER_CHANGE_EMAIL_MS: number = 8000;
